import { AccommodationPlacePartner } from './AccommodationPlacePartner';

export default AccommodationPlacePartner;
